import { scorEn } from './scor';
const en = {
  translation: {
    scor: scorEn,
    back: 'Back',
    selectAppLanguage: 'Select application language',
    russianLang: 'Russian',
    englishLang: 'English',
    youAlwaysCanChangeLangInPreferences:
      'You always can change language in preferences',
    continuePhrase: 'Continue',
    cancel: 'Cancel',
    chatImagesPreview: 'Preview photos',
    chatPasteMoreImages: 'You can paste more photos from the clipboard.',
    phoneCodeUkraine: 'Ukraine (+380)',
    phoneCodeBelarus: 'Belarus (+375)',
    phoneCodeUSA: 'USA (+1)',
    phoneCodeRussia: 'Russia (+7)',
    phoneCodeSwitzerland: 'Switzerland (+41)',
    phoneCodeUAE: 'UAE (+971)',
    phoneCodeKazakhstan: 'Kazakhstan (+7)',
    phoneCodeEstonia: 'Estonia (+372)',
    phoneCodeBelgium: 'Belgium (+32)',
    phoneCodeLithuania: 'Lithuania (+370)',
    phoneCodeCanada: 'Canada (+1)',
    phoneCodeCzech: 'Czech (+420)',
    phoneCodeSpain: 'Spain (+34)',
    phoneCodeJapan: 'Japan (+81)',
    inputPhoneNumber: 'Input phone number',
    somethingWentWrongPleaseContactSupport:
      'Something went wrong. Please, contact support.',
    verification: 'Verification',
    requestCodeIn: 'Request code after {{time}} sec.',
    codeHasBeenSentToNumber: 'Code has been sent to number',
    smsCode: 'Code',
    requestCodeAgain: 'Request code again',
    checkYourConnectionError: 'Server is unreachable. Check your connection',
    serverError: 'Server error. Please, try again later',
    otpAttemptsLimitExceededError:
      'The number of attempts to enter the code has been exceeded',
    setupAccessCode: 'Setup security code',
    repeatAccessCode: 'Repeat security code',
    enterAccessCode: 'Enter security code',
    invalidPincode: 'Invalid password',
    pincodeDoesNotMatch: 'pincodeDoesNotMatch',
    forgotPassword: 'Forgot password?',
    biometricLoginMessage: 'Login',
    biometricSetupMessage: 'Use biometrics as the main method of authorization',
    doYouWantToChooseBiometricsAsTheMainLoginMethod:
      'Do you want to choose biometrics as the main method of authorization?',
    yesAnswer: 'Yes',
    noAnswer: 'No',
    biometry: 'Biometry',
    otpTooManyAttempts:
      'You entered the wrong code 3 times in a row and you will not be able to log in to the system for 10 minutes. Try again in {{time}}',
    biometryVerifyIdentity: 'Verify identity',
    biometryAuthentification: 'biometryAuthentification',
    biometryNotRecognized: 'Not recognized',
    biometrySettings: 'Settings',
    biometrySettingsDescription: 'Allow biometry on your device',
    biometrySuccess: 'Recognized successfully',
    portfolioLabel: 'Portfolio',
    ordersLabel: 'Orders',
    chatLabel: 'Chat',
    profileLabel: 'Profile',
    yourPortfolio: 'Your portfolio',
    analytics: 'Analytics',
    displayPortfolioChartInfoNeedApiKeys:
      'To display portfolio information broker account number and API required',
    portfolioChartInputData: 'Input data',
    chartPeriodWeek: 'Week',
    chartPeriodMonth: 'Month',
    chartPeriodMonth3: '3 months',
    chartPeriodMonth6: '6 months',
    chartPeriodCurYear: 'YTD',
    chartPeriodYear: 'Year',
    chartPeriodAllHistory: 'All',
    error: 'Error',
    tryAgain: 'Try again',
    portfolioChartDataIsEmpty:
      'Your portfolio history is loading at the moment. It will be available within the next 24 hours!',
    goal: 'Goal',
    createGoal: 'Create goal',
    createGoalDescription: 'Create target to invest your future',
    createGoalDescription2:
      "You are able to create several goals for different accounts. But you can't create more than one goal for one account. ",
    portfolioSectionTitle: 'Money amount',
    portfolioOpenedPositionsTitle: 'Open positions',
    portfolioDealsHistoryTitle: 'Deals History',
    goalProgress: '{{current}} of {{desired}}',
    okUppercased: 'OK',
    portfolioNoApiKeysTitle: 'Portfolio details',
    displayPortfolioNeedApiKeys:
      'To display portfolio information broker account number and API required',
    portfolioInputData: 'Input data',
    openedPositionsQuantity: '{{quantity}} item(s) {{price}}',
    dealsHistoryTableTicker: 'Ticker',
    dealsHistoryTableDate: 'Date',
    dealsHistoryTableQuantity: 'Quantity',
    dealsHistoryTableResult: 'Result',
    dealsHistoryTableGrossProfit: 'Gross profit',
    dealsHistoryTableFees: 'Fees',
    dealsHistoryTableOpenFee: 'Open fee',
    dealsHistoryTableCloseFee: 'Close fee',
    dealsHistoryTableTotalFees: 'Total fees',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    operationTypeBuyAsset: 'Buy asset',
    operationTypeSellAsset: 'Sell asset',
    operationTypeBlockFunds: 'Block funds',
    operationTypeUnblockFunds: 'Unblock funds',
    operationTypeDealFee: 'Deal fee',
    operationTypeSuccessFee: 'Success fee',
    operationTypeUnlockAsset: 'Unlock asset',
    operationTypeUnknown: 'Unknown operation',
    dealsHistoryTableOperations: 'Operations',
    noOperationsFound: 'No operations found',
    loadingOperations: 'Loading operations...',
    noDealsFound: 'No deals found',
    listIsEmpty: 'List is empty',
    apiKeys: 'API keys',
    accountNumber: 'Account number',
    portfolioSettings: 'Portfolio setup',
    events: 'Events',
    createReport: 'Create report',
    portfolio: 'Portfolio',
    companies: 'Companies',
    income: 'Income',
    replenishment: 'Replenishment',
    circulation: 'Circulation',
    withdrawal: 'Withdrawal',
    companiesCount1: '{{count}} company',
    companiesCount2: '{{count}} companies',
    companiesCount3: '{{count}} companies',
    companiesCount4: '{{count}} companies',
    noDataForSelectedPeriod: 'No data for selected period',
    eventBuyStocks: 'Buy stocks',
    eventSellStocks: 'Sell stocks',
    eventBuyCurrency: 'Buy currency',
    eventSellCurrency: 'Sell currency',
    eventUnknownOperation: 'Unknown operation',
    eventCommissionWithAmount: 'Commission {{amount}}',
    today: 'Today',
    yesterday: 'Yesterday',
    reports: 'Reports',
    brokerageReport: 'Brokerage report',
    brokerageReportDescription:
      'What securities do you own, how much money have been deposited and withdrawn',
    sendReportToEmail: 'Send to email',
    periodToLabel: 'Period to',
    periodFromLabel: 'Period from',
    email: 'Email',
    invalidEmail: 'Invalid email',
    fieldIsRequired: 'Field is required',
    reportSent: 'Report sent to emal',
    newGoal: 'New goal',
    createGoalForm1Description1:
      "To begin with, let's define the “base” from which we can start on to build a strategy to achieve the goal:",
    initialDepositLabel: '$ Initial deposit',
    desiredPassiveIncomeLabel: '$ Desired passive income',
    desiredPassiveIncomeHint: 'Desired monthly passive investment income',
    goalAgeLabel: 'Age-reference to the goal',
    goalAgeHint: 'At what age do you want to reach your goal',
    createGoalForm2Title: 'Income',
    createGoalForm2Description1:
      'Fine! But for a more accurate calculation, we need a little more data.',
    currentIncomeLabel: '$ Your current monthly income',
    incomeShareLabel: 'Income share %',
    incomeShareHint: 'Share of income that will be used to accumulate savings',
    monthlySavingsLabel: '$ Monthly savings',
    replenishmentMonthLabel: 'Replenishment month',
    replenishmentMonthHint:
      'From what month on account after the first installment do you plan to deposit funds monthly?',
    createGoalForm3Title: 'Spendings',
    createGoalForm3Description1:
      "Great, we're almost done, there are some finishing touches left.",
    createGoalForm3Description2:
      'Are you planning any expenses? If not, skip this step.',
    createGoalForm3Description3:
      'How many months after reaching the desired passive income do you want to make this purchase?',
    expectedSpendingsAmountLabel: '$ Expected purchase amount',
    expectedSpendingsAmountHint: 'Enter the expected amount for this purchase',
    spendingMonthLabel: 'Purchase month',
    createGoalForm4Title: 'Final',
    createGoalForm4Description1:
      "Super! Now let's give a name to your goal. Once we are done, you will be able to see the progress towards achieving it.",
    goalNameLabel: 'Goal name',
    goalAmountLabel: 'Goal',
    howManyMonthsToWithdrawLabel: 'How many months to withdraw',
    howManyMonthsToWithdrawHint: 'From what month do we replenish monthly',
    next: 'Next',
    goalCancelCreatingTitle: 'Cancel creation?',
    goalCancelCreatingText:
      'Are you sure you want to cancel the creation? All entered data will be lost',
    getBack: 'Back',
    cancelAction: 'Cancel',
    create: 'Create',
    select: 'Select',
    goalAge: 'Age',
    fieldMaxNum: 'Max possible value is {{num}}',
    fieldMinNum: 'Min possible value is {{num}}',
    personalInfo: 'Personal information',
    phoneNumber: 'Phone number',
    notifications: 'Notifications',
    pushNotifications: 'Push notifications',
    sms: 'SMS',
    security: 'Security',
    loginUsingBiometry: 'Login using biometric',
    settings: 'Settings',
    appLanguage: 'App language',
    changeSecurityCode: 'Change security code',
    logout: 'Logout',
    useAdditionalPhoneForSms: 'Use additional phone for SMS',
    additionalPhone: 'Additional phone',
    specifyPhoneNumber: 'Specify',
    add: 'Add',
    invalidPhoneNumber: 'Invalid phone number',
    enterNewAccessCode: 'Enter new security code',
    enterOldAccessCode: 'Enter old security code',
    accessCodeHasBeenUpdated: 'Security code has been updated',
    updateAccessCode: 'Update security code',
    goalCreated: 'Goal created',
    orders: 'Orders',
    orderBuyAction: 'Buy',
    orderSellAction: 'Sell',
    orderUnknownAction: 'Unknown',
    orderBuyMarginAction: 'Buy margin',
    orderSellShortAction: 'Sell margin',
    orderByMarket: 'By market',
    confirmOrder: 'Confirm',
    ordersCurrentStatusGroup: 'Current',
    ordersClosedStatusGroup: 'Closed',
    orderID: 'ID',
    orderDate: 'Date',
    orderName: 'Name',
    orderOperation: 'Operation',
    orderStatus: 'Status',
    orderPrice: 'Price',
    orderType: 'Order type',
    orderQuantity: 'Shares quantity',
    orderCreatedAt: 'Order create date',
    orderAmount: 'Amount',
    orderRemain: 'Remain',
    orderExpiration: 'Expiration',
    orderStatusIgnored: 'Ignored',
    orderStatusReceived: 'Received',
    orderStatusCancelInProgress: 'Cancel in progress',
    orderStatusActive: 'Active',
    orderStatusSent: 'Sent',
    orderStatusPartiallyFilled: 'Partially filled',
    orderStatusPartiallyDone: 'Partially done',
    orderStatusDone: 'Done',
    orderStatusPartiallyCanceled: 'Partially canceled',
    orderStatusAdminDeclined: 'Declined by admin',
    orderStatusRejected: 'Rejected',
    orderStatusExpired: 'Expired',
    orderStatusPartiallyDoneAndExpired: 'Partially done and expired',
    orderStatusSendingError: 'Sending error',
    orderStatusCancelError: 'Cancel error',
    orderStatusNew: 'New',
    orderStatusProcessed: 'Processed',
    orderStatusClientDeclined: 'Client declined',
    orderStatusInvalidOrderStatus: 'Invalid order status',
    orderStatusDeclined: 'Declined',
    orderStatusUnknown: 'Unknown',
    orderStopPrice: 'Stop price',
    orderLimitPrice: 'Limit price',
    orderVolume: 'Volume',
    orderTypeMarket: 'Market',
    orderTypeLimit: 'Limit',
    orderTypeStop: 'Stop',
    orderTypeStopLimit: 'Stop limit',
    orderTypeUnknown: 'Unknown',
    orderCompletedAt: 'Complete',
    orderExpirationDay: 'Until end of trading session',
    orderExpirationDay24h: 'Day/Night or Night/Day',
    orderExpirationUntilCanceled: 'Until canceled',
    orderExpirationUnknown: 'Unknown',
    orderIpoOrderType: 'IPO',
    orderPortfolioShare: 'Portfolio share',
    sell: 'Sell',
    buy: 'Buy',
    orderUnderstand: 'Understand',
    orderConfirmation: 'Order confirmation',
    ordersNoApiKeysDescription:
      'To display orders, broker account number and API are required',
    ordersEnterApiKeys: 'Input data',
    apiKeysAllDoneTitle: 'All done!',
    apiKeysProposalToConnectDescription:
      'You have successfully registered in the application. There is only one action left - to connect the accounts of brokers.',
    connect: 'Connect',
    apiKeysConnectLater: 'Connect later',
    connectBrokerAccountTitle: 'Connect broker account',
    tradernetBroker: 'Tradernet',
    freedomBroker: 'Freedom',
    tinkoffBroker: 'T-Investments',
    finamBroker: 'Finam',
    selectBrokerDescription:
      'Select to connect the broker you use. This will allow you to track the portfolio and operations on it in the application',
    tradernetBrokerConnectDescription:
      'For full-fledged work, you will need to keep ali-keys and account number. This can be done automatically by receiving two SMS codes, or manually.',
    brokerExitSetup: 'Exit setup',
    brokerConnectManually: 'Manually',
    brokerConnectAutomatically: 'Automatically',
    tradernetAuthEnterPhoneDescription:
      'Linked to your Freedom Finance account',
    tradernetAuthVerifyPhoneTitle: 'Login into your FREEDOM finance account',
    tradernetAuthVerifyPhoneDescription:
      'We will contact the broker via api. You only need to confirm authorization. Enter the confirmation code from FREEDOM finance, it will be sent via SMS',
    tradernetTokenVerifyOtpTitle: 'Confirm token creating',
    tradernetTokenVerifyOtpDescription:
      'You will need the Freedom Finance token for the full operation of the application, we have already requested it. Confirm the creation of a token with a code from SMS, the creation of a token with a code from SMS.',
    tradernetAddKeysManually: 'Add manually',
    somethingWentWrong: 'Something went wrong',
    failedToCreateFreedomFinanceToken:
      'For the full operation of the application, you must enter your account and API keys. Follow the prompts on the screen to add them manually.',
    getApiKeys: 'Get API Keys',
    skip: 'Skip',
    done: 'Done',
    theApplicationIsReady: 'The application is ready',
    apiKeysGoToHome: 'Start',
    apiPublicKey: 'Public key',
    apiPrivateKey: 'Private key',
    brokerAccounts: 'Broker accounts',
    unknownBroker: 'Unknown',
    brokerAccount: 'Broker account',
    brokerAccountNotFound: 'Broker account not found',
    edit: 'Edit',
    brokerAccountHasBeenUpdated: 'Broker account has been updated',
    save: 'Save',
    delete: 'Delete',
    attention: 'Attention',
    areYouSureDeleteBrokerAccount:
      'Are you sure you want to delete this broker account?',
    chatCommunityManager: 'Community Manager',
    chatPersonalManager: 'Personal Manager',
    chatSystemMessages: 'System messages',
    chatUnknownName: 'Chat',
    chatMessagePlaceholder: 'Message...',
    chatCopyMessage: 'Copy text',
    chatRepeatSending: 'Repeat sending',
    filesCount1: '{{count}} file',
    filesCount2: '{{count}} files',
    filesCount3: '{{count}} files',
    filesCount4: '{{count}} files',
    openFileNoPermission: 'No permission to open a file',
    openFileFormatDoesNotSupport: 'File format is not supported by device',
    openFileNotFound: 'File not found',
    cancelOrder: 'Cancel order',
    cancelOrderConfirmationText: 'Are you sure you want to cancel this order?',
    closeAction: 'Close',
    search: 'Search',
    fileUploadingError: 'File uploading failed',
    analyticsWithdrawal: 'Withdrawal',
    loginHeadTitle: 'Authorization',
    notFoundHeadTitle: 'Not found',
    balance: 'Balance',
    accountAlreadyConnected: 'Account is already connected',
    tradernetSelectAccount: 'Select broker account',
    tradernetSelectAccountDescription:
      'Select a broker account. This will allow you to track the portfolio and operations on it in the application.',
    tinkoffBrokerConnectDescription:
      'To work, you will need to maintain an account token. Follow the instructions on the screen to add it.',
    tinkoffBrokerConnectStep1_1: 'Log in to your personal account using ',
    tinkoffBrokerConnectStep1_2: 'this link',
    tinkoffBrokerConnectStep2:
      'Scroll down to the Tokens section and click “Create Token”',
    tinkoffBrokerConnectStep3:
      'Select the full access token, copy it and paste the token into the field',
    tinkoffAddingToken: 'Add token',
    token: 'Token',
    connectBrokerAction: 'Connect broker account',
    accountNotFound: 'Account not found',
    brokerAccountHasBeenDeleted: 'Broker account has been deleted',
    accountLabel: 'Broker account',
    formHasError: 'Form was filled with errors. Please fix them and try again.',
    orderCanceled: 'Order was successfully canceled',
    orderConfirmed: 'Order was successfully confirmed',
    sendMessage: 'Send message',
    selectChat: 'Select chat',
    chatNotFound: 'Chat not found',
    attachFiles: 'Attach files',
    filesUploading: 'Files uploading',
    fileIsTooBigMb:
      'The file "{{name}}" is too big. Its size cannot exceed {{size}} MiB.',
    peDeals: 'PE deals',
    myDealsLabel: 'My actives',
    newDealsLabel: 'New deals',
    p2pDealsLabel: 'P2P deals',
    myOrdersLabel: 'My orders',
    makePERequest: 'Make Private Equity request',
    makePERequestDescription:
      'Purchase of a share of non-public companies within private financing rounds before entering IPO.',
    selectService: 'Services',
    myDealsTitle: 'My deals',
    newDealsTitle: 'New deals',
    p2pDealsTitle: 'P2P deals',
    myOrdersTitle: 'My orders',
    dealStartedAt: 'Deal started date',
    dealEndedAt: 'Deal close date',
    sharesQuantity: "Shares' quantity",
    sharesVolume: 'Volume',
    dealOrderType: 'Order type',
    dealOrderTypeBuy: 'Buy',
    dealOrderTypeSell: 'Sell',
    dealOrderStatus: 'Order status',
    dealOrderStatusWaitForApproval: 'Waiting for approval',
    dealOrderStatusActive: 'Active',
    dealOrderStatusCompleted: 'Completed',
    dealOrderStatusCanceled: 'Canceled',
    dealOrderCreatedAt: 'Order create date',
    dealOrderSellPrice: 'Shares sell price',
    dealOrderBuyPrice: 'Shares buy price',
    currentSharesPrice: 'Current shares price',
    unknown: 'Unknown',
    areYouSureYouWantToCancelOrder:
      'Are you sure you want to cancel the order?',
    currentPeOrders: 'Current',
    closedPeOrders: 'Closed',
    peCompanyDetails: 'Company details',
    peCompanyFoundationDate: 'Foundation date',
    peCompanyHeadOffice: 'Head office',
    peCompanySector: 'Sector',
    peCompanyIndustry: 'Industry',
    peCompanyRevenue: 'Revenue',
    peCompanyEmployees: 'Employees',
    peCompanyBusinessModel: 'Business model',
    peCompanyTakeovers: 'Takeovers',
    peCompanyWebsite: 'Website',
    peCompanyDescription: 'Description',
    peCompanyValue: 'Value',
    peCompanyInvestors: 'Investors',
    peCompanyCompetitors: 'Competitors',
    peCompanyTeam: 'Team',
    peInvest: 'Invest',
    orderWasCanceled: 'Order was canceled',
    sharesQuantityLabel: 'Shares quantity',
    sharesPriceLabel: '{{currency}} Shares price',
    sharesBuyVolumeLabel: '{{currency}} Total purchase amount',
    sharesSellVolumeLabel: '{{currency}} Total sales amount',
    peMakeRequest: 'Make a request',
    peOrderCreated: 'Order was created',
    activePeDeals: 'Active',
    closedPeDeals: 'Closed',
    servicesLabel: 'Services',
    peCompanyTitle: 'Company',
    peSharesDealPrice: 'Shares deal price',
    peOperationType: 'Operation type',
    confirm: 'Confirm',
    serviceTemplateDescription: 'Description',
    serviceTemplateForWhomDescription: 'For whom',
    templateEntryPriceValue: 'from {{price}}',
    templateEntryPriceLabel: 'Entry threshold',
    peCompanyReport: 'Report',
    download: 'Download',
    loadingProcess: 'Loading...',
    navCommunity: 'Community',
    AI: 'ai',
    navMobileApp: 'Mobile app',
    navServices: 'Services',
    navMediaPortal: 'Media portal',
    navAccount: 'Account',
    authWarningText:
      'Never share your SMS code and/or password with anyone. A real SharesPro employee will never ask for them.\nMake sure the code came from SharesPro sender or in the SharesPro app push notification.\n\nBy clicking "Continue", you confirm your consent to the processing of personal data and accept the terms of the user agreement.',
    signInSharespro: 'Sign in SharesPro',
    authorization: 'Authorization',
    enterCodeFromSms: 'Enter code from SMS',
    navMain: 'Main',
    navSettings: 'Settings',
    navScor: 'SCOR',
    areYouSureYouWanToLogout: 'Are you sure you want to logout?',
    selectGenderMale: 'Male',
    selectGenderFemale: 'Female',
    phoneLabel: 'Phone',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    middleNameLabel: 'Middle name',
    emailLabel: 'Email',
    birthdayLabel: 'Birthday',
    genderLabel: 'Gender',
    navAccounts: 'Accounts',
    profilePhoneInputDescription:
      'To link a new phone, write to support or call your personal manager if you are a SharesPro customer.',
    pageTitleAccounts: 'Linked broker accounts',
    brokerAccountStatusValid: 'Connected',
    brokerAccountStatusInvalid: 'Error',
    brokerAccountStatusNotFilled: 'Connecting',
    newAccountTitle: 'New account',
    newAccountText:
      'By connecting an account, you can track its dynamics and portfolio analytics.',
    selectBrokerTitle: 'Select broker',
    connectTinkoffBrokerTitle: 'Connect T-Investments account',
    tinkoffCode: 'Code',
    connectTradernetBrokerTitle: 'Connect Tradernet broker',
    tradernetBrokerConnectStep1_1: 'Log in to your personal account using ',
    tradernetBrokerConnectStep1_2: 'this link',
    tradernetBrokerConnectStep2_1: 'Generate an API Key using ',
    tradernetBrokerConnectStep2_2: 'this link',
    tradernetBrokerConnectStep3: 'Click the "Create a new key pair" button.',
    tradernetBrokerConnectStep4:
      'Copy and paste the public and private keys into the fields.',
    brokerAccountWasCreated: 'Broker account was successfully added',
    connectBrokerAccount: 'Connect account',
    incomeChartTitle: 'Income chart',
    moreDetails: 'More details',
    downloadReport: 'Download report',
    currencies: 'Currencies',
    operations: 'Operations',
    operationsTableName: 'Name',
    operationsTableDate: 'Date',
    operationsTableAmount: 'Amount',
    openedPositionsTableTicker: 'Ticker',
    openedPositionsTableQuantity: 'Quantity',
    openedPositionsTableEntryPrice: 'Entry price',
    openedPositionsTableCurrentPrice: 'Current price',
    openedPositionsTableBuyAmount: 'Buy amount',
    openedPositionsTableResult: 'Result',
    openedPositionsTableTotalValue: 'Total value',
    fillTheProfile: 'Please, fill the profile',
    fillTheProfileAction: 'Fill the profile',
    noAccountsDescription:
      'You will not be able to track portfolio dynamics and analytics without connecting your account',
    noAccountsAction: 'Connect account',
    recommendations: 'Recommendations',
    recommendedOrderStatus: 'Status',
    recommendedOrderQuantity: 'Quantity',
    recommendedOrderPrice: 'Price',
    recommendedOrderTotal: 'Total',
    recommendedOrderHoursAgo: '{{hours}} h.',
    recommendedOrderDaysAgo: '{{days}} d.',
    sharesproOffers: 'SharesPro offers',
    p2pOffers: 'P2P offers',
    investorsOffers: "Investors' offers",
    allItems: 'All',
    productsTitle: 'Products',
    strategiesTitle: 'Strategies',
    strategy1Title: 'Conservative strategy',
    strategy1Subtitle: '11% per year',
    strategy1Text: 'Preservation of capital and stable profit',
    strategy2Title: 'Crypto strategy',
    strategy2Subtitle: '42% per year',
    strategy2Text: 'High returns and high risks',
    strategy3Title: 'TECH strategy',
    strategy3Subtitle: '22% per year',
    strategy3Text: 'Long term capital growth',
    servicesTitle: 'Services',
    service1Title: 'Citizenship of Vanuatu',
    service1Text: 'The opportunity to visit many countries without a visa.',
    service2Title: 'Transfer of assets',
    service2Text: 'Transfer from sub-sanctioned brokers to eliminate risks.',
    service3Title: 'Tax planning',
    service3Text: "Legal optimization of the investor's tax burden",
    service4Title: 'Cards',
    service4Text:
      'Registration of a foreign bank card in Turkey, Kazakhstan and Tajikistan.',
    service5Title: 'Tax planning',
    service5Text: "Legal optimization of the investor's tax burden.",
    service6Title: 'Transfer of assets',
    service6Text:
      'Transfer of funds from sub-sanctioned brokers in order to eliminate possible risks.',
    myRecommendations: 'My recommendations',
    navTrends: 'Trends',
    recommendationNumber: 'Recommendation №{{id}}',
    openedPositionsTableQuantityCell: '{{quantity}} for {{price}}',
    buyOrderRequest: 'Buy order request',
    sellOrderRequest: 'Sell order request',
    peOffers: 'PE offers',
    pePrice: 'Price',
    peSharesQuantity: 'Shares quantity',
    peOfferPrice: 'Offer price',
    peLastRoundPrice: 'Last round price',
    peLastRoundDate: 'Last round date',
    peLastRoundVolume: 'Last round volume',
    leaveRequest: 'Leave a request',
    profileUpdated: 'Profile was successfully updated',
    peCreateOrderOperationLabel: 'What do you want to do',
    peCompanyEstimateFromAnalytics: 'Estimate by analytics',
    peCompanyClients: 'Clients',
    peCompanyInvestmentsHistory: 'Investments history',
    peCompanyInvestmentsChart: 'Investments chart',
    peCompanyAssets: 'Assets',
    peEstimateProduct: 'Product',
    peEstimateIndustry: 'Industry',
    peEstimateInvestors: 'Investors',
    peEstimatePartners: 'Partners',
    peEstimateCompetitors: 'Competitors',
    peEstimateFinances: 'Finances',
    peEstimateTeam: 'Team',
    peEstimateReputation: 'Reputation',
    peEstimateClients: 'Clients review',
    peFinanceHistoryDate: 'Date',
    peFinanceHistoryType: 'Type',
    peFinanceHistoryRaised: 'Raised, $mln',
    peFinanceHistoryLeadInvestors: 'Lead Investors',
    peCompetitorsEstimate: 'Estimate',
    peCompetitorsStockType: 'Stock type',
    peCompetitorsTypeOfRevenueGrowth: 'Revenue',
    peCompetitorsRaised: 'Raised',
    peCompetitorsEmployees: 'Employees',
    peCompetitorsCountry: 'Country',
    peCompetitorsFoundation: 'Foundation year',
    peAssetAccount: 'Account',
    peAssetQuantity: 'Quantity',
    peAssetAmount: 'Amount',
    peAssetIncome: 'Income',
    quantityWithSuffix: '{{quantity}} pcs.',
    peCompanySharesPrice: 'Shares price',
    peCreateOrderCompanyName: 'Company name',
    peCreateOrderAmount: 'Amount',
    peCreateOrderSharePrice: 'Shares buy price',
    peCreateOrderComment: 'Additional comments or questions',
    peCreateOrderQuantity: 'Quantity',
    peYourRequestWasSent: 'Your request was sent',
    peManagerWillContactYou: 'Manager will contact you as soon as possible',
    peOrder: 'Order',
    status: 'Status',
    peActiveTotalAmount: "Active's amount",
    peActivePurchaseTotalAmount: 'Purchase amount',
    peActiveRevenuePercent: 'Revenue',
    orderStateActive: 'Active',
    orderStateArchived: 'Archived',
    peDealStateActive: 'Active',
    peDealStateArchived: 'Archived',
    raised: 'Raised',
    allChats: 'All chats',
    peEstimateActionBuy: 'Buy',
    peEstimateActionHold: 'Hold',
    peEstimateActionSell: 'Sell',
    pageOf: 'Page {{current}} of {{total}}',
    requestCallManagerServiceText:
      'Do you want to contact the manager for more detailed information about the service?',
    requestCallManagerProductText:
      'Do you want to contact the manager for more detailed information about the product?',
    requestCallManagerStrategyText:
      'Would you like to contact the manager for more information about the strategy?',
    requestCallManagerAccept: 'Yes, contact the manager',
    requestCallManagerDecline: 'No, thanks',
    requestCallManagerSuccess:
      'Thank you for submitting your application! Our manager will be happy to answer your questions.',
    submitRequest: 'Submit Request',
    requestCallManagerNotificationText: 'Would you like to contact the manager for more detailed information?',
    peSidebarRequestCardText:
      'Buy shares of non-public companies in funding rounds before entering the IPO.',
    skolkovoResidentTitle: 'Skolkovo Innovation Center Resident',
    skolkovoResidentDescription:
      'The research is carried out by SharesPro Ltd. with the grant support of the Skolkovo Fund',
    copyright1:
      "All rights reserved. Users are prohibited from copying any Site Content in full or partially for commercial or public purposes without Site owner's written permission. In case of violation, those responsible may be held liable in accordance with the current legislation of the Russian Federation",
    copyright2: 'Services provided by a partner company SharesPro Consulting',
    copyright3: '© SharesPro {{year}}',
    addressLabel: 'Address',
    addressValue:
      '4 Podkopaevsky Lane, Building A, 4th floor, Moscow, 109028',
    privacyPolicy: 'Privacy Policy',
    userAgreement: 'User Agreement',
    soutResults: 'SAWC Report',
    strategy1Advantage1Label: 'We exceed VWIAX dynamics by',
    strategy1Advantage2Label: 'Average annual volality',
    strategy1Advantage3Label: 'Average annual performance',
    strategy1Advantage4Label: 'The best return for the year',
    strategy1Advantage5Label: 'Years with negative returns',
    strategy1Advantage6Label: 'Years with positive returns',
    strategy1Advantage7Label: 'The worst performance for the year',
    strategy1Advantage8Label: 'Years with a yeild above 5%',
    strategy1Advantage1Value: '1,60%',
    strategy1Advantage2Value: '5,03%',
    strategy1Advantage3Value: '8,52%',
    strategy1Advantage4Value: '15,20%',
    strategy1Advantage5Value: '0 of 7',
    strategy1Advantage6Value: '7 of 7',
    strategy1Advantage7Value: '0.51%',
    strategy1Advantage8Value: '4 of 7',
    strategy2Advantage1Label: 'We exceed Bitcoin dynamics by',
    strategy2Advantage2Label: 'Average annual volality',
    strategy2Advantage3Label: 'Average annual performance',
    strategy2Advantage4Label: 'The best return for the year',
    strategy2Advantage5Label: 'Years with negative returns',
    strategy2Advantage6Label: 'Years with positive returns',
    strategy2Advantage7Label: 'The worst performance for the year',
    strategy2Advantage8Label: 'Years with a yeild above 10%',
    strategy2Advantage1Value: '143,00%',
    strategy2Advantage2Value: '71,30%',
    strategy2Advantage3Value: '239,30%',
    strategy2Advantage4Value: '650,10%',
    strategy2Advantage5Value: '1 of 4',
    strategy2Advantage6Value: '3 of 4',
    strategy2Advantage7Value: '-65,10%',
    strategy2Advantage8Value: '3 of 4',
    strategy3Advantage1Label: 'We exceed NASDAQ dynamics by',
    strategy3Advantage2Label: 'Average annual volality',
    strategy3Advantage3Label: 'Average annual performance',
    strategy3Advantage4Label: 'The best return for the year',
    strategy3Advantage5Label: 'Years with negative returns',
    strategy3Advantage6Label: 'Years with positive returns',
    strategy3Advantage7Label: 'The worst performance for the year',
    strategy3Advantage8Label: 'Years with a yeild above 10%',
    strategy3Advantage1Value: '52,00%',
    strategy3Advantage2Value: '58,50%',
    strategy3Advantage3Value: '67,20%',
    strategy3Advantage4Value: '167,00%',
    strategy3Advantage5Value: '1 of 9',
    strategy3Advantage6Value: '8 of 9',
    strategy3Advantage7Value: '-30,50%',
    strategy3Advantage8Value: '8 of 9',
    strategyIndicators: 'Strategy indicators',
    strategyIndicatorRisk: 'Risk',
    strategyIndicatorLongTerm: 'Long term',
    strategyIndicatorYield: 'Yield',
    strategyIndicatorReliability: 'Reliability',
    strategyModelIncomeTitle: 'Model performance since 2015',
    strategyModelIncome: 'Income',
    strategyPortfolioComposition: 'Portfolio composition',
    advantages: 'Advantages',
    aboutStrategy: 'About strategy',
    strategyPortfolio: 'Portfolio',
    strategyIncomeChart: 'Performance chart',
    strategyApplyCardDescription:
      'To display the composition of the strategy, you need to become a SharesPro client.',
    strategyApply: 'Apply',
    strategyEntryThreshold: 'Entry threshold',
    peTabInfo: 'Information',
    peTabNews: 'News',
    peTabOrderBook: 'Order book',
    survey: 'Survey',
    generalSurveyQuestion1: 'Evaluate the quality of SharesPro service',
    generalSurveyQuestion2:
      'Evaluate the quality of investment offers SharesPro',
    generalSurveyQuestion3:
      'How likely are you to recommend SharesPro to someone you know?',
    generalSurveyQuestion4: 'What could we change for you to give us a 10?',
    finishSurvey: 'Finish survey',
    yourAnswer: 'Your answer',
    generalSurveyOfferCard: 'Please complete the Sharespro Quality Survey',
    startSurvey: 'Start',
    thanksForSurveyFeedback: 'Thank you for feedback',
    noData: 'No data',
    orderBookIsEmpty: 'Order book is empty',
    chartDataIsPreparing:
      'The data is being processed. The process may take several hours.',
    orderTableBuy: 'Buy',
    orderTableSell: 'Sell',
    videoFromEvent: 'Video from event',
    photosFromEvent: 'Photos from event',
    eventTopics: 'Event topics',
    eventInvestmentsDirections: 'Investments directions',
    eventVideoReviews: 'Video reviews',
    eventDescription: 'About',
    eventDownloadPresentation: 'Download presentation',
    eventRegister: 'Register',
    nextEventHasNotScheduledYet: 'Next event has not scheduled yet',
    singUpForTheWaitingList: 'Sign up for the waiting list',
    nextEvents: 'Upcoming events',
    prevEvents: 'Passed events',
    sharesproStrategies: 'SharesPro strategies',
    upcomingEvents: 'Upcoming events',
    youJoinedToEvent: 'You joined to event',
    youRegisteredToWaitingList: 'You registered to waiting list',
    eventStatusUpcomingTag: 'Register',
    eventStatusArchivedTag: 'Archived',
    declineAction: 'Decline',
    connectFreedomTitle: 'Connect Freedom',
    connectFinam: 'Connect Finam',
    finamBrokerConnectStep1_1: 'Register at ',
    finamBrokerConnectStep1_2: 'Comon',
    finamBrokerConnectStep1_3:
      ', using the phone number associated with your Finam account.',
    finamBrokerConnectStep2_1: 'To create a token in Comon, go to ',
    finamBrokerConnectStep2_2: 'this link',
    finamBrokerConnectStep2_3:
      '. Or Personal Account > Accounts > Trade API. Click the Create Token button.',
    finamBrokerConnectStep3:
      'Select an account, enter the name of the token, indicate the type - Trading.',
    finamBrokerConnectStep4: 'Check the box, unlimited.',
    finamBrokerConnectStep5: 'Copy and paste the token account into the field.',
    finamBrokerConnectStep6: 'Copy and paste the token into the field.',
    finamAccountField: 'Account',
    finamTokenField: 'Token',
    stateOfPortfolio: 'The state of your portfolio',
    myAccount: 'My account',
    minNumValue: 'Min required amount is {{amount}}',
    improveAppFeedbackTitle: 'Help us make SharesPro better! ',
    improveAppFeedbackText: 'Please, share your feedback',
    improveAppFeedbackFillForm: 'Survey',
    improveAppFeedbackEverythingIsGood: 'All fine',
    cryptoAccount: 'Crypto portfolio',
    peAccount: 'IPO/PE',
    arbitrAccount: 'Arbitrage trading',
    updatePhoto: 'Edit photo',
    addProfilePhoto: 'Add photo',
    fileTooBigMb: 'The size of the file cannot exceed {{size}} MiB.',
    newRecommendations: 'New recommendations',
    pleaseApproveRecommendations: 'Please, approve recommendations',
    pleaseApproveRebalancing: 'Please, approve rebalancing',
    approveAllRecommendations: 'Approve',
    privateChannel: 'Private channel',
    noAccess: 'No access',
    commentariesCount1: '{{count}} comment',
    commentariesCount2: '{{count}} comments',
    commentariesCount3: '{{count}} comments',
    commentariesCount4: '{{count}} comments',
    leaveAComment: 'Leave a comment',
    commentEdited: 'edited',
    commentsDiscussion: 'Discussion',
    comments: 'Comments',
    commentInputPlaceholder: 'Comment...',
    commentWasDeleted: 'Comment was deleted',
    commentWasAdded: 'Comment was added',
    commentWasUpdated: 'Comment was updated',
    loadMore: 'Load more',
    editComment: 'Comment editing',
    privateChannelNoAccessTitle: 'You are not a member of the community',
    privateChannelNoAccessText:
      'We are sorry that you are not yet a member of our community and cannot view exclusive information, analyst reviews and private discussions.',
    joinCommunity: 'Join the community',
    privateChannelRequestSent: 'Private channel requests sent',
    assetSum: 'Asset sum',
    entryPrice: 'Entry price',
    eventManager: 'Event manager',
    allOrdersHaveBeenApproved: 'All orders have been approved.',
    binanceTitle: 'Binance',
    connectBinance: 'Connect Binance',
    binanceApiKeyField: 'API key',
    binanceSecretKeyField: 'Secret key',
    binanceBrokerConnectStep1_1: 'Log in to your Binance account using ',
    binanceBrokerConnectStep1_2: 'the link.',
    binanceBrokerConnectStep2: 'Click “profile”- “API management”',
    binanceBrokerConnectStep3_1:
      'Click “Create API”. Please note that before creating an API Key, you need to enable ',
    binanceBrokerConnectStep3_2: 'two-factor authentication (2FA)',
    binanceBrokerConnectStep3_3:
      ' on your account make a deposit of any amount to your Spot Wallet to activate your account.',
    binanceBrokerConnectStep4: 'Select your preferred API Key type.',
    binanceBrokerConnectStep5: 'Enter a label/name for your API Key.',
    binanceBrokerConnectStep6:
      'Verify your request with 2FA devices and passkeys.',
    binanceBrokerConnectStep7:
      'Activate the security management methods by unchecking the box.',
    binanceBrokerConnectStep8:
      'Check the boxes “Enable Reading” and “Enable Spot&Margin Trading”',
    binanceBrokerConnectStep9:
      'Copy and paste API key and Secret key in the fields below',
    hintScreen: 'Hint-screen',
    mainIntroTitle: 'Your independent analyst and financial advisor',
    featuresSectionTitle:
      'What an investor gets by joining the  SharesPro community',
    leaveWithdrawalRequestPlease: 'To withdraw funds, please, leave a request',
    viewWithdrawalRequests: 'View all requests',
    requestCreating: 'Request creating',
    withdrawalFromAccount: 'Withdrawal',
    currency: 'Currency',
    wallet: 'Wallet',
    createRequest: 'Create a request',
    withdrawalRequests: 'Withdrawal requests',
    requestWaitingProcessing: 'Awaiting processing',
    requestProcessing: 'Processing',
    requestDone: 'Done',
    requestRejected: 'Rejected',
    withdrowalAmount: 'Total',
    withdrawalRequestCreatedSuccessfully:
      'The withdrawal request has been created successfully',
    orderStatusCanceled: 'Canceled',
    withdrawalOrderDate: 'Order date',
    withdrawalOrderAmount: 'Order amount',
    walletAddress: "Кошелек",
    myDocuments: 'My documents',
    sign: 'Sign',
    awaitSign: 'Awaiting signing',
    signed: 'Signed',
    signDocSms: 'To sign the document, please, \nenter the SMS code',
    homeDocCardTitle: 'Documents to sign',
    homeDocCardDescription: 'Please review and sign the documents',
    document: 'Document',
    codeHasBeenSendToNumberDocument: 'Code has been sent to number',
    declineVote: 'Decline vote',
    byte: 'b',
    kilobyte: 'Kb',
    megabyte: 'Mb',
    gigabyte: 'Gb',
    privateChat: 'Private Chat',
    investGroup: 'Invest Club Group',
    telegramTitle:
      'To receive SMS codes and copies of push notifications from the SharesPro application in Telegram, please connect the Telegram channel. You can find it by the name @SharesPro_bot or by following the',
    telegramTitleLink: 'link',
    telegramFirst: 'Start a dialogue with the bot by using /start command',
    telegramSecond:
      'Enter the phone number in international format with which you log into the SharesPro application\n\n',
    telegramThird:
      'You will receive SMS message with a code that you need to send in a dialogue with the bot',
    disable: 'Disable',
    enable: 'How to enable',
    codeMethod: 'Method of receiving codes',
    disableTelegram: 'Are you sure you want to disable Telegram?',
    enabled: 'enabled',
    disabled: 'disabled',
    connectionTelegram: 'Telegram connection',
    compensationCardTitle: 'Compensation',
    compensationCardText:
      'You are eligible for compensation for the transaction Convoy',
    compensationPageTitle: 'Compensations',
    accrualCompensation: 'accrual',
    writeOffCompensation: 'write-off',
    noCompensationAvailable: 'Compensations not available',
    compensationPageTextFirst:
      'In case of bankruptcies (or other possible losses), the company may decide to compensate for these losses at the expense of its own commissions.',
    compensationPageTextSecond:
      'In this section, you can see whether there is compensation for your transactions and track the progress of its balance.',
    balanceCompensation: 'Balance compensation ',
    'lock-up': 'Lock-up',
    editAccountName: 'Edit account name',
    amountIsRequired: 'Amount is required',
    amountIsLow: 'Amount should be greater than 1',
    amountExceedsAvailable: 'Amount exceeds available for withdrawal',
    currencyIsRequired: 'Currency is required',
    walletIsRequired: 'Wallet is required',
    availableForWithdrawal: 'Available for withdrawal',
    available: 'Available',
    selfIpoTitle: 'IPO',
    selfIpoApplicationsTitle: 'My IPO applications',
    selfIpoApplicationsProfileButton: 'IPO applications',
    selfIpoApplicationsActiveTab: 'Active',
    selfIpoApplicationsCancelledTab: 'Canceled',
    selfIpoAmount: 'Amount',
    selfIpoPriceRange: 'Price range',
    selfIpoMinAmount: 'Minimum amount',
    selfIpoAcceptanceDeadline: 'Acceptance deadline',
    selfIpoDeadlineShort: 'until {{date}}',
    selfIpoApplicationsCount: 'Applications count',
    selfIpoCardOpenStatus: 'Open',
    selfIpoCardClosedStatus: 'Closed',
    selfIpoOpenForApplications: 'Open',
    selfIpoClosedForApplications: 'Closed',
    selfIpoEligibilityReady: 'You can submit an application',
    selfIpoEligibilityNoPortfolio: 'No Self IPO portfolio. Please contact your manager',
    selfIpoEligibilityBookClosed: 'The deadline has passed and the book is closed',
    selfIpoEligibilityInsufficientBalance: 'Insufficient portfolio balance',
    selfIpoEligibilityAlreadyApplied: 'You have already applied for this offering',
    selfIpoCurrentApplication: 'Current application',
    selfIpoSubmittedAt: 'Submitted at',
    selfIpoCashBalance: 'Cash balance',
    selfIpoHoldBalance: 'Hold balance',
    selfIpoAssetBalance: 'Assets value',
    selfIpoBalance: 'Balance',
    selfIpoPortfolio: 'Portfolio',
    selfIpoDealFee: 'Deal fee',
    selfIpoSuccessFee: 'Success fee',
    selfIpoLockUpDays: 'Lock-up, days',
    selfIpoSector: 'Sector',
    selfIpoDescription: 'Description',
    selfIpoStatusSubmitted: 'Submitted',
    selfIpoStatusAllocated: 'Allocated',
    selfIpoStatusNotAllocated: 'Not allocated',
    selfIpoStatusClosed: 'Closed',
    selfIpoStatusCancelled: 'Cancelled',
    selfIpoAllocationPercent: 'Allocation, %',
    selfIpoAllocatedAmount: 'Allocated amount',
    selfIpoBuyPrice: 'Buy price',
    selfIpoBuyQuantity: 'Shares quantity',
    selfIpoBuyDate: 'Buy date',
    selfIpoUnlockDate: 'Unlock date',
    selfIpoProfitPercent: 'Current profit, %',
    selfIpoFixedProfitPercent: 'Fixed profit, %',
    selfIpoApplyAction: 'Submit application',
    selfIpoContactManagerAction: 'Contact manager',
    selfIpoTopUpAction: 'Top up balance',
    selfIpoApplyAmountLabel: 'Application amount, $',
    selfIpoApplySuccess: 'Application submitted successfully',
    selfIpoContactManagerSuccess:
      'Request submitted. Your manager will contact you',
    selfIpoTopUpSuccess: 'Balance top-up request submitted',
    selfIpoCancelSuccess: 'Application cancelled successfully',
    selfIpoCancelConfirmation: 'Are you sure you want to cancel this application?',
    selfIpoMinAmountValidation: 'Minimum application amount: {{amount}}$',
    selfIpoAmountExceedsAllowed: 'Amount exceeds allowed limit',
    selfIpoCashBalanceHelper: 'Cash balance: {{amount}}$',
    "ai": "AI",
    "createNewChat": "Create new chat",
    "newChat": "New chat",
    "noChatsFound": "No chats found",
    "selectChatFromList": "Select a chat from the list on the left",
    "enterMessage": "Enter message...",
    "errorCreatingChat": "Error creating chat:",
    "errorSendingMessage": "Error sending message:",
    "aiChat": "AI chat",
    "confirmDeleteTitle": "Delete chat",
    "confirmDeleteBody": "Are you sure you want to delete this chat? This action is irreversible.",
    autofollowActive: 'Autofollowing is active',
    pauseAutofollow: 'Pause autofollowing',
    pauseAutofollowConfirmationText:
      'The strategy is operating normally. Click "Confirm" if you want to temporarily stop trading - all assets will be sold automatically, and following the strategy will be disabled.\n\n⚠️Warning: assets are sold at market prices and may be unfavorable during high volatility. You can resume the strategy only manually through the app.',
    autofollowPaused: 'Autofollowing is paused',
    resumeAutofollow: 'Resume autofollowing',
    resumeAutofollowConfirmationText:
      'The strategy is disabled. To resume participation, click "Confirm" and the portfolio will start forming again.\n\n⚠️Warning: current positions in the account will be closed to form the strategy portfolio.',
    privacyPolicyLink: 'processing of personal data',
    termsOfServiceLink: 'user agreement',
    mondayShort: "Mon",
    tuesdayShort: "Tue",
    wednesdayShort: "Wed",
    thursdayShort: "Thu",
    fridayShort: "Fri",
    saturdayShort: "Sat",
    sundayShort: "Sun",
    januaryGenitive: "January",
    februaryGenitive: "February",
    marchGenitive: "March",
    aprilGenitive: "April",
    mayGenitive: "May",
    juneGenitive: "June",
    julyGenitive: "July",
    augustGenitive: "August",
    septemberGenitive: "September",
    octoberGenitive: "October",
    novemberGenitive: "November",
    decemberGenitive: "December",
  },
};

export default en;
